import React from 'react';
import { Repeat } from 'sushiweb/Icons';
import { Tooltip, CopyText } from '../../../../UiKit';
import { grey } from 'sushiweb/tokens/color';
import { viewText, headPhone } from '../../../../images/images';
import { WFHCall } from '../../../commons';
import { UserPrimaryNumberCallClickEvent } from '../../../../analytics/call-logging/events';

export const UserNumber = ({
  number = 'xxxxxxxxxx',
  numberInfo = null,
  calledTo,
  isWFH = false,
  orderId = null,
  userId = null,
  isNewUser = false,
  unmaskNumber = () => {},
  regenerateNumber = () => {},
  hasAlternativeContact = false,
  cartId = null,
}) => {
  return (
    <div>
      <span className='icon iconMarginR'>
        <img src={headPhone} alt='' />
      </span>
      <Tooltip
        position='bottom'
        border={!hasAlternativeContact}
        title={
          <React.Fragment>
            {numberInfo ? (
              <CopyText
                orderId={orderId}
                title={numberInfo.phone}
                masking={false}
                calledTo={calledTo}
              />
            ) : (
              <div className='masked'>
                {number}
                <span
                  className='pointer icon iconMarginL tw-mr-2'
                  onClick={() => unmaskNumber(false)}
                >
                  <img src={viewText} alt='' />
                </span>
              </div>
            )}
          </React.Fragment>
        }
        fontWeight={'300'}
        label={hasAlternativeContact ? 'Sender Contact Number' : ''}
      />
      {numberInfo && numberInfo.show_reload_button && (
        <Tooltip
          position='bottom'
          title={
            <div
              className='pointer'
              onClick={() =>
                regenerateNumber(numberInfo.masked_number_popup, false)
              }
            >
              <Repeat size={18} color={grey.z500} />
            </div>
          }
          label='Renew Masked Number'
        />
      )}
      {isWFH ? (
        <WFHCall
          orderId={orderId}
          userId={userId}
          isNewUser={isNewUser}
          pos='top'
          isUser={true}
          calledTo={calledTo}
          isAltContact={false}
          altContactMissing={!hasAlternativeContact}
          sendJumboEvent={true}
          jumboEventFunc={UserPrimaryNumberCallClickEvent}
          JumboEventProperties={{
            is_new_ui: false,
            user_number: numberInfo?.phone,
            called_to: calledTo,
          }}
          cartId={cartId}
        />
      ) : null}
    </div>
  );
};
